import { LOCAL_STORAGE_HOME_EXPLORE_COLLECTION_MODAL_KEY } from './constants';

export function getShouldHideExploreCollectionModal() {
  const localStorageData = window.localStorage.getItem(
    LOCAL_STORAGE_HOME_EXPLORE_COLLECTION_MODAL_KEY,
  );
  const shouldHideExploreCollectionModal = localStorageData && JSON.parse(localStorageData);

  return shouldHideExploreCollectionModal === true;
}

export function setShouldHideExploreCollectionModal() {
  window.localStorage.setItem(
    LOCAL_STORAGE_HOME_EXPLORE_COLLECTION_MODAL_KEY,
    JSON.stringify(true),
  );
}
